module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.status === 'grant') ? _c('span', {
    staticClass: "grant"
  }, [_vm._v("Aprovado")]) : _vm._e(), _vm._v(" "), (_vm.status === 'deny') ? _c('span', {
    staticClass: "deny"
  }, [_vm._v("Rejeitado")]) : _vm._e(), _vm._v(" "), (_vm.status === 'processing') ? _c('span', {
    staticClass: "processing"
  }, [_vm._v("Em análise")]) : _vm._e(), _vm._v(" "), (_vm.status === 'pendency') ? _c('span', {
    staticClass: "pendency"
  }, [_vm._v("Sob correção")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b3caaa9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/RequestStatus.vue
// module id = 1407
// module chunks = 1